document.addEventListener("DOMContentLoaded", function (event) {
  var dataindex = $(".static-variants-subscription")
    .find("input:checked")
    .parent()
    .data("index");

  const handlePoundsPulled = async (style, subscription) => {
    console.log(style);
    console.log(subscription);
    if (
      style == "Beaded" &&
      subscription == "Bracelet of the Month Club - Beaded - Monthly"
    ) {
      $(".product__pounds-pulled > b").html("10 pounds");
      console.log("1");
    } else if (
      style == "Braided" &&
      subscription == "Bracelet of the Month Club - Braided - Monthly"
    ) {
      $(".product__pounds-pulled > b").html("10 pounds");
      console.log("2");
    } else if (
      style == "2-Bracelet Set" &&
      subscription == "Bracelet of the Month Club - Set - Monthly"
    ) {
      $(".product__pounds-pulled > b").html("20 pounds");
      console.log("3");
    } else if (
      style == "Beaded" &&
      subscription == "Bracelet of the Month Club - Beaded - 3 Months"
    ) {
      $(".product__pounds-pulled > b").html("30 pounds");
      console.log("4");
    } else if (
      style == "Braided" &&
      subscription == "Bracelet of the Month Club - Braided - 3 Months"
    ) {
      $(".product__pounds-pulled > b").html("30 pounds");
      console.log("5");
    } else if (
      style == "2-Bracelet Set" &&
      subscription == "Bracelet of the Month Club - Set - 3 Months"
    ) {
      $(".product__pounds-pulled > b").html("60 pounds");
      console.log("6");
    } else if (
      style == "Beaded" &&
      subscription == "Bracelet of the Month Club - Beaded - 6 Months"
    ) {
      $(".product__pounds-pulled > b").html("60 pounds");
      console.log("7");
    } else if (
      style == "Braided" &&
      subscription == "Bracelet of the Month Club - Braided - 6 Months"
    ) {
      $(".product__pounds-pulled > b").html("60 pounds");
      console.log("8");
    } else if (
      style == "2-Bracelet Set" &&
      subscription == "Bracelet of the Month Club - Set - 6 Months"
    ) {
      $(".product__pounds-pulled > b").html("120 pounds");
      console.log("9");
    } else if (
      style == "Beaded" &&
      subscription == "Bracelet of the Month Club - Beaded - 12 Months"
    ) {
      $(".product__pounds-pulled > b").html("120 pounds");
      console.log("10");
    } else if (
      style == "Braided" &&
      subscription == "Bracelet of the Month Club - Braided - 12 Months"
    ) {
      $(".product__pounds-pulled > b").html("120 pounds");
      console.log("11");
    } else if (
      style == "2-Bracelet Set" &&
      subscription == "Bracelet of the Month Club - Set - 12 Months"
    ) {
      $(".product__pounds-pulled > b").html("240 pounds");
      console.log("12");
    } else {
      console.log("13");
    }
  };

  $(".static-variants-subscription")
    .find("input")
    .change(function () {
      var symbol = $("body").data("currency_sym");
      var curcode = $("body").data("currency_code");
      $('.sticky-banner__container input[name="id"]').val($(this).val());
      $('input[name="selling_plan"]').val($(this).data("sellingplan"));
      var price = Number($(this).data("price"));
      var cprice = price;
      $(".price__container").html(Shopify.formatMoney(cprice) + " " + curcode);
      $(".sticky-banner__title").html($(this).data("title"));
      $(".product__title .ptitle-sub").html($(this).data("title"));
      var pid = $(this).attr("id").replace("item-subscription-", "");
      $(".subscription-media-gallery").hide();
      $('.subscription-media-gallery[data-pid="' + pid + '"]').show();
      // $(".product__description").hide();
      // $('.product__description[data-pid="' + pid + '"]').show();
      dataindex = $(this).parent().data("index");
      let style = $(
        ".static-variants-style > .static-variants > .swatch-item > input:checked"
      ).val();
      let subs = $(
        ".static-variants-subscription > .static-variants > .swatch-item > input:checked"
      ).data("title");
      handlePoundsPulled(style.trim(), subs.trim());
    });

  $(".static-variants-style")
    .find("input")
    .change(function () {
      $(".static-variants-subscription").find(".swatch-item").hide();
      $(".static-variants-subscription")
        .find('.swatch-item[data-type="' + $(this).val() + '"]')
        .show();
      $(".static-variants-subscription")
        .find('.swatch-item[data-type="' + $(this).val() + '"]')
        .show();

      $(".static-variants-subscription")
        .find(
          '.swatch-item[data-type="' +
            $(this).val() +
            '"][data-index="' +
            dataindex +
            '"]'
        )
        .find('input[type="radio"]')
        .prop("checked", true);
      var checkedinput = $(".static-variants-subscription").find(
        "input:checked"
      );
      var symbol = $("body").data("currency_sym");
      var curcode = $("body").data("currency_code");
      $('.sticky-banner__container input[name="id"]').val(checkedinput.val());
      $('input[name="selling_plan"]').val(checkedinput.data("sellingplan"));
      var price = Number(checkedinput.data("price"));
      var cprice = price;
      $(".price__container").html(Shopify.formatMoney(cprice) + " " + curcode);
      $(".sticky-banner__title").html(checkedinput.data("title"));
      $(".product__title .ptitle-sub").html(checkedinput.data("title"));
      var pid = checkedinput.attr("id").replace("item-subscription-", "");
      // console.log(pid);
      $(".subscription-media-gallery").hide();
      $('.subscription-media-gallery[data-pid="' + pid + '"]').show();
      // $(".product__description").hide();
      // $('.product__description[data-pid="' + pid + '"]').show();
      dataindex = checkedinput.parent().data("index");
      let style = $(
        ".static-variants-style > .static-variants > .swatch-item > input:checked"
      ).val();
      let subs = $(
        ".static-variants-subscription > .static-variants > .swatch-item > input:checked"
      ).data("title");
      handlePoundsPulled(style.trim(), subs.trim());
    });
});
